var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngledArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.815686 0 0 0 0 0.007843 0 0 0 0 0.105882 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EID---My-Tasks",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Tasks---Approver---Details---Business-Request---Interactions",
    transform: "translate(-1439.000000, -1325.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drawer",
    transform: "translate(461.500000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "organism/pdp/content/business/normal",
    transform: "translate(0.500000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mt/organisms/decision-table/type-5",
    transform: "translate(0.000000, 463.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mt/molecules/tables3/decision-sm/sod-violation",
    transform: "translate(0.000000, 736.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a/icons/16/arrow-45-up",
    transform: "translate(970.000000, 14.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3972118,6.40531773 C12.4018544,6.1297267 12.2939415,5.86415404 12.0983864,5.66991143 C11.9028314,5.47566883 11.6365381,5.36954669 11.3609846,5.376045 C11.0885746,5.37182119 10.8263878,5.4796762 10.6358024,5.67436111 C10.4452169,5.86904602 10.3429652,6.1334684 10.3529846,6.40572682 L10.3529846,8.59395409 C10.3526689,8.63508174 10.3278428,8.67205308 10.2898935,8.68790982 C10.2519442,8.70376656 10.2081945,8.69544899 10.1787118,8.66677227 L5.24712092,3.81413591 C5.01803001,3.585045 4.47721183,3.42345409 3.94130274,3.96059046 C3.54601756,4.28653168 3.48536945,4.86933637 3.80507547,5.26968137 L8.66548456,10.1746814 C8.69451976,10.2039721 8.70312023,10.2478365 8.68729562,10.2859228 C8.67147101,10.3240092 8.63431841,10.3488635 8.59307547,10.3489541 L6.32712092,10.3489541 C5.76228424,10.3489541 5.30439365,10.8068447 5.30439365,11.3716814 C5.30439365,11.936518 5.76228424,12.3944086 6.32712092,12.3944086 L11.9881209,12.3944086 C12.2140556,12.3944086 12.3972118,12.2112524 12.3972118,11.9853177 L12.3972118,6.40531773 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "translate(7.998678, 7.997204) scale(1, -1) translate(-7.998678, -7.997204) "
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngledArrow);
export default __webpack_public_path__ + "static/media/angled-arrow.8362f44d1d59adfa3548ec82054f2294.svg";
export { ForwardRef as ReactComponent };